import React from 'react';
import { ContainerStatus, WrapperIcon } from './styles';

export interface Props {
  icon: string;
  title: string;
  colorTitle: string;
  children?: React.ReactNode;
}

const Status = ({ icon, title, colorTitle, children }: Props) => {
  return (
    <ContainerStatus>
      <WrapperIcon>
        <svg width="80px" height="80px" viewBox="0 0 50 50">
          <use xlinkHref={icon} />
        </svg>
        <h1 color={colorTitle}>{title}</h1>
      </WrapperIcon>
      {children}
    </ContainerStatus>
  );
};
export default Status;
